module.exports = __webpack_public_path__ + "media/images/illustrations/undraw_ask_me_anything-28918eee4115a45aeaa3bd0423475fdb.svg";